// material-ui
import { useTheme } from '@mui/material/styles';

// ==============================|| LOGO ICON SVG ||============================== //

import logo from 'assets/images/kambatime-logo.png';

export default function LogoIcon() {
  return (
    <div style={{ width: '38px', height: '38px', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
      <img src={logo} alt="KambaTime GPO" height="38" style={{ objectFit: 'cover', objectPosition: 'left' }} />
    </div>
  );
}
